function Error() {
    return (
        <div className='contact-card'>
            <h2 className='content'>Error: página no encontrada</h2>
        </div>
    )
}

export default Error